import React, { useEffect, useState } from 'react';
import { Header } from './components/Header';
import { MobileBottomBar } from './components/MobileBottomBar';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { MentalWellness } from './pages/MentalWellness';
import { SymbisCoaching } from './pages/SymbisCoaching';
import { AboutUs } from './pages/AboutUs';
import { ContactUs } from './pages/ContactUs';
export function App() {
  const [view, setView] = useState(window.location.hash || '#home');
  useEffect(() => {
    const handleHashChange = () => setView(window.location.hash || '#home');
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  const renderView = () => {
    switch (view) {
      case '#services':
        return <Services data-id="element-0" />;
      case '#mental-wellness':
        return <MentalWellness data-id="element-1" />;
      case '#symbis-coaching':
        return <SymbisCoaching data-id="element-2" />;
      case '#about-us':
        return <AboutUs data-id="element-3" />;
      case '#contact-us':
        return <ContactUs data-id="element-4" />;
      default:
        return <Home data-id="element-5" />;
    }
  };
  return <div className="min-h-screen flex flex-col font-sans selection:bg-[#B8860B]/30" data-id="element-6">
      <Header data-id="element-7" />
      {renderView()}
      <MobileBottomBar data-id="element-8" />

      {/* Footer */}
      <footer className="bg-[#F8F9FA] py-12 border-t border-[#588157]/10 pb-32 lg:pb-12" data-id="element-9">
        <div className="container mx-auto px-4" data-id="element-10">
          <div className="grid md:grid-cols-4 gap-12 mb-12" data-id="element-11">
            <div className="col-span-2" data-id="element-12">
              <a href="#home" className="flex items-center gap-2 mb-6 hover:opacity-80 transition-opacity" data-id="element-13">
                <div className="w-8 h-8 bg-[#588157] rounded-full flex items-center justify-center" data-id="element-14">
                  <span className="text-[#F8F9FA] font-serif text-sm font-bold" data-id="element-15">
                    G
                  </span>
                </div>
                <h2 className="text-[#588157] font-serif font-bold text-xl" data-id="element-16">
                  Global Restorative
                </h2>
              </a>
              <p className="text-[#1A374D]/70 max-w-sm mb-6" data-id="element-17">
                Bridging the gap between primary medical care and holistic
                mental wellness. Restoring, Renewing, and Rebuilding lives
                through integrated healthcare.
              </p>
            </div>
            <div data-id="element-18">
              <h4 className="font-bold text-[#588157] mb-6 uppercase tracking-widest text-sm" data-id="element-19">
                Quick Links
              </h4>
              <ul className="space-y-4 text-[#1A374D]/70" data-id="element-20">
                <li data-id="element-21">
                  <a href="#services" className="hover:text-[#588157] transition-colors" data-id="element-22">
                    Medical Services
                  </a>
                </li>
                <li data-id="element-23">
                  <a href="#mental-wellness" className="hover:text-[#588157] transition-colors" data-id="element-24">
                    Mental Wellness
                  </a>
                </li>
                <li data-id="element-25">
                  <a href="#symbis-coaching" className="hover:text-[#588157] transition-colors" data-id="element-26">
                    SYMBIS Coaching
                  </a>
                </li>
                <li data-id="element-27">
                  <a href="#" className="hover:text-[#588157] transition-colors" data-id="element-28">
                    Patient Portal
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-29">
              <h4 className="font-bold text-[#588157] mb-6 uppercase tracking-widest text-sm" data-id="element-30">
                Contact
              </h4>
              <ul className="space-y-4 text-[#1A374D]/70 font-medium" data-id="element-31">
                <li data-id="element-32">info@globalrestorative.com</li>
                <li data-id="element-33">+1 (443) 949-981</li>
                <li data-id="element-34">15627 Elsmere Ct</li>
                <li data-id="element-35">Bowie, MD 20716</li>
              </ul>
            </div>
          </div>
          <div className="pt-8 border-t border-[#588157]/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-[#1A374D]/50" data-id="element-36">
            <p data-id="element-37">
              © 2026 Global Restorative Health & Wellness LLC. All rights
              reserved.
            </p>
            <div className="flex gap-8" data-id="element-38">
              <a href="#" className="hover:text-[#588157]" data-id="element-39">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-[#588157]" data-id="element-40">
                Terms of Service
              </a>
              <a href="#" className="hover:text-[#588157]" data-id="element-41">
                HIPAA Compliance
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}